import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ComprobanteService } from '@facturacion/comprobante.service';
import { ExportExcelServiceService } from '@shared/exportar-excel/export-excel-service.service';
import { CierreCaja } from '@shared/models/cierreTurno/CierreCaja';
import { Comprobante } from '@shared/models/facturacion/Comprobante';
import { PagoContado } from '@shared/models/facturacion/PagoContado';
import { Renglon } from '@shared/models/facturacion/Renglon';
import { VisorComprobanteComponent } from '@shared/visor-comprobante/visor-comprobante.component';
import { MessageService } from '@shell/message.service';
import { PagoElectronicoDto } from '@shared/models/facturacion';
import { FacturaService } from '@shared/factura.service';
import { FacturaCierreCaja } from '@shared/models/cierreTurno/FacturaCierreCaja';
@Component({
  selector: 'app-detalle-cierre-caja',
  templateUrl: './detalle-cierre-caja.component.html',
  styleUrls: ['./detalle-cierre-caja.component.css']
})
export class DetalleCierreCajaComponent implements OnInit, OnChanges {
  @Input() cierreSeleccionado: CierreCaja;

  obteniendoFacturas: boolean = false;
  comprobante: Comprobante;
  totalDeFacturas: number = 0;
  diferencia: number = 0;


  constructor(
    private facturacionService: ComprobanteService, 
    private messageService: MessageService,
    private activeModal: NgbModal, 
    private excelService: ExportExcelServiceService,
    private facturaService: FacturaService) { }

  ngOnInit() {
    this.obteniendoFacturas = true;
    this.totalDeFacturas = 0;
    this.diferencia = 0;
    this.cierreSeleccionado.facturas.forEach((value, index) => {
      this.totalDeFacturas += this.cierreSeleccionado.facturas[index].total - this.getTotalTarjetas(this.cierreSeleccionado.facturas[index].pago) - this.getTotalPagosElectronicos(this.cierreSeleccionado.facturas[index].pagosElectronicos);
    });
    this.diferencia = this.cierreSeleccionado.totalEfectivoIngresado - this.totalDeFacturas;
    this.obteniendoFacturas = false;
  }

  ngOnChanges() {
    this.ngOnInit();
  }

  mostrarFacrtura(factura: any) {
    factura.buscarComprobante = true;
    this.facturacionService.obtenerComprobantePorId(factura.id)
      .subscribe(result => {
        this.comprobante = result;
        factura.buscarComprobante = false;
        if (this.comprobante != null) {
          const modalRef = this.activeModal.open(VisorComprobanteComponent, { centered: true, size: 'lg' });
          modalRef.componentInstance.facturaObtenida = this.comprobante;
        } else {
          factura.buscarComprobante = false;
          this.messageService.showErrorMessage('Error al obtener la factura');
        }
      }, () => {
        factura.buscarComprobante = false;
        this.messageService.showErrorMessage('Error al obtener la factura');
      });
  }

  obtenerProductos(renglones: Renglon[]){
    let string: string = '';
    for(const prod of renglones){
      string += prod.productoCodigo + '-' + prod.productoNombre + '. '
    }
    return string;
  }

  armarArrayExcel() {
    const excelCaja: ExcelCaja[] = [];
    for (const c of this.cierreSeleccionado.facturas) {
      const item = new ExcelCaja();
      item.Cliente = c.cliente;
      item.Factura = c.prefijo + '-' + c.numeroComprobante;
      item.Fecha = c.fechaEmision;
      item.PagoConTarjeta = this.getTotalTarjetas(c.pago);
      item.PagoElectronico = this.getTotalPagosElectronicos(c.pagosElectronicos);
      item.PagoEfectivo = this.getTotalEfectivo(c);
      item.Producto = this.obtenerProductos(c.renglones);
      item.Usuario = c.responsable;
      excelCaja.push(item);
    }
    return excelCaja;
  }

  getTotalTarjetas(pago: PagoContado[]): number {
    return this.facturaService.calcularTotalCuponesCierre(pago);
  }

  getTotalPagosElectronicos(pay: PagoElectronicoDto[]): number {
    return this.facturaService.calcularTotalPagosElectronicos(pay);
  }

  getTotalEfectivo(factura: FacturaCierreCaja): number {
    return factura.total - this.getTotalTarjetas(factura.pago) - this.getTotalPagosElectronicos(factura.pagosElectronicos);
  }

  exportar() {
    this.excelService.exportAsExcelFile(this.armarArrayExcel(), 'Cierre de caja ' + this.cierreSeleccionado.fechaHora + ' Responsable: ' + this.cierreSeleccionado.responsable);
  }

  print(): void {
    const divToPrint = document.getElementById('invoicingPrint');
    let htmlToPrint = '' +
      '<style type="text/css">' +
      'table, table td, table th  {' +
      'border:1px solid #000;' +
      'text-align: center;' +
      'padding:0.5em;' +
      '}' +
      'button{' +
      'display: none;' +
      '}' +
      'label  {' +
      'margin-top: 0.5cm;' +
      'display: inline-block;' +
      '}' +
      '#noPrint {' +
      'display: none;' +
      '}' +
      '</style>';
    htmlToPrint += divToPrint.outerHTML;
    const newWin = window.open("");
    newWin.document.write(htmlToPrint);
    newWin.print();
    newWin.close();
  }

}

export class ExcelCaja {
  Cliente: string;
  Factura: string;
  Producto: string;
  Fecha: string;
  PagoConTarjeta: number;
  PagoElectronico: number;
  PagoEfectivo: number;
  Usuario: string;
}
